export function dashboardModifiedTimeEntriesItemTemplate($templateCache) {
    'ngInject';
    const path = "/Scripts/Page/Home/apex-dashboard-item-template-modified-time-entries.html";
    const html = /*html*/`<apex-dashboard-modified-time-entries-container>
        </apex-dashboard-modified-time-entries-container>`;
    $templateCache.put(path, html);
}

export function dashboardModifiedTimeEntriesListItemTemplate($templateCache) {
    'ngInject';
    const path = "/Scripts/Page/Home/apex-dashboard-list-item-template-modified-time-entries.html";
    const html = /*html*/`
        <div ng-if="dashboard.count > 0">
            <p>Your employer has modified some of your time entries.</p>
            <span class="btn btn-primary"
                ng-click="vm.acknowledgeAll(dashboard.Data)"
                ng-disabled="vm.allAcknowledged(dashboard.Data)">Acknowledge All</span>
        </div>
        <div ng-if="dashboard.count === 0">
            <p>
                <span class="glyphicon fas fa-check-circle"></span>
                There are no modified time entries awaiting your acknowledgment.
            </p>
        </div>`;
    $templateCache.put(path, html);
}
